/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ControllerResponse_ExportResult_ } from '../models/ControllerResponse_ExportResult_';
import type { ControllerResponse_string_ } from '../models/ControllerResponse_string_';
import type { ExportGranularity } from '../models/ExportGranularity';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class ExportService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Export building-level data
     *
     * Exports aggregated building data including prices, quality scores,
     * pricing strategy metrics, and review data.
     * @param msa The MSA (Metropolitan Statistical Area) code to export
     * @param minUnits Minimum number of units filter
     * @param maxUnits Maximum number of units filter
     * @param minYearBuilt Minimum year built filter
     * @param maxYearBuilt Maximum year built filter
     * @param isSingleFamily Filter for single-family properties
     * @param isCondo Filter for condominiums
     * @param isApartment Filter for apartments
     * @param isSenior Filter for senior housing
     * @param isBuildToRent Filter for build-to-rent housing
     * @param isStudent Filter for student housing
     * @param isAffordable Filter for affordable housing
     * @returns ControllerResponse_ExportResult_ Download URL and metadata for the exported file
     * @throws ApiError
     */
    public exportBuilding(
        msa: string,
        minUnits?: number,
        maxUnits?: number,
        minYearBuilt?: number,
        maxYearBuilt?: number,
        isSingleFamily?: boolean,
        isCondo?: boolean,
        isApartment?: boolean,
        isSenior?: boolean,
        isBuildToRent?: boolean,
        isStudent?: boolean,
        isAffordable?: boolean,
    ): CancelablePromise<ControllerResponse_ExportResult_> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/export/building',
            query: {
                'msa': msa,
                'min_units': minUnits,
                'max_units': maxUnits,
                'min_year_built': minYearBuilt,
                'max_year_built': maxYearBuilt,
                'is_single_family': isSingleFamily,
                'is_condo': isCondo,
                'is_apartment': isApartment,
                'is_senior': isSenior,
                'is_build_to_rent': isBuildToRent,
                'is_student': isStudent,
                'is_affordable': isAffordable,
            },
        });
    }
    /**
     * Export unit-level data
     *
     * Exports individual unit/listing data including floorplan info,
     * bed/bath counts, prices, and market dates.
     * @param msa The MSA (Metropolitan Statistical Area) code to export
     * @param minUnits Minimum number of units in the building
     * @param maxUnits Maximum number of units in the building
     * @param minYearBuilt Minimum year built filter
     * @param maxYearBuilt Maximum year built filter
     * @param isSingleFamily Filter for single-family properties
     * @param isCondo Filter for condominiums
     * @param isApartment Filter for apartments
     * @param isSenior Filter for senior housing
     * @param isBuildToRent Filter for build-to-rent housing
     * @param isStudent Filter for student housing
     * @param isAffordable Filter for affordable housing
     * @param fromDate Filter units that entered market on or after this date (YYYY-MM-DD)
     * @param toDate Filter units that exited market on or before this date (YYYY-MM-DD)
     * @returns ControllerResponse_ExportResult_ Download URL and metadata for the exported file
     * @throws ApiError
     */
    public exportUnit(
        msa: string,
        minUnits?: number,
        maxUnits?: number,
        minYearBuilt?: number,
        maxYearBuilt?: number,
        isSingleFamily?: boolean,
        isCondo?: boolean,
        isApartment?: boolean,
        isSenior?: boolean,
        isBuildToRent?: boolean,
        isStudent?: boolean,
        isAffordable?: boolean,
        fromDate?: string,
        toDate?: string,
    ): CancelablePromise<ControllerResponse_ExportResult_> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/export/unit',
            query: {
                'msa': msa,
                'min_units': minUnits,
                'max_units': maxUnits,
                'min_year_built': minYearBuilt,
                'max_year_built': maxYearBuilt,
                'is_single_family': isSingleFamily,
                'is_condo': isCondo,
                'is_apartment': isApartment,
                'is_senior': isSenior,
                'is_build_to_rent': isBuildToRent,
                'is_student': isStudent,
                'is_affordable': isAffordable,
                'from_date': fromDate,
                'to_date': toDate,
            },
        });
    }
    /**
     * Export price history data
     *
     * Exports historical price records for units, showing how prices
     * changed over time.
     *
     * Note: Building-level filters (min_units, year_built, property types) are NOT
     * supported for price history exports. Only MSA and date range filters are available.
     * @param msa The MSA (Metropolitan Statistical Area) code to export
     * @param fromDate Filter price records starting on or after this date (YYYY-MM-DD)
     * @param toDate Filter price records ending on or before this date (YYYY-MM-DD)
     * @returns ControllerResponse_ExportResult_ Download URL and metadata for the exported file
     * @throws ApiError
     */
    public exportPriceHistory(
        msa: string,
        fromDate?: string,
        toDate?: string,
    ): CancelablePromise<ControllerResponse_ExportResult_> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/export/price-history',
            query: {
                'msa': msa,
                'from_date': fromDate,
                'to_date': toDate,
            },
        });
    }
    /**
     * Export concession history data
     *
     * Exports historical concession/special offers data for buildings,
     * including conditions and discount details.
     *
     * Note: Building-level filters (min_units, year_built, property types) are NOT
     * supported for concession exports. Only MSA and date range filters are available.
     * @param msa The MSA (Metropolitan Statistical Area) code to export
     * @param fromDate Filter concession records starting on or after this date (YYYY-MM-DD)
     * @param toDate Filter concession records ending on or before this date (YYYY-MM-DD)
     * @returns ControllerResponse_ExportResult_ Download URL and metadata for the exported file
     * @throws ApiError
     */
    public exportConcession(
        msa: string,
        fromDate?: string,
        toDate?: string,
    ): CancelablePromise<ControllerResponse_ExportResult_> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/export/concession',
            query: {
                'msa': msa,
                'from_date': fromDate,
                'to_date': toDate,
            },
        });
    }
    /**
     * Get data dictionary for a specific export granularity
     *
     * Returns a CSV file describing the columns in the exported data,
     * including field names, data types, and descriptions.
     * @param granularity The export type to get the dictionary for
     * @returns ControllerResponse_string_ CSV content of the data dictionary
     * @throws ApiError
     */
    public getDictionary(
        granularity: ExportGranularity,
    ): CancelablePromise<ControllerResponse_string_> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/export/dictionary/{granularity}',
            path: {
                'granularity': granularity,
            },
        });
    }
}
